import React from "react";

const LABELS = { fr: "Français", es: "Español" };

export const LanguageToggle = ({ lang, onChange }) => (
  <div className="inline-flex items-center rounded-full border border-[var(--border)] bg-white/70 p-1 no-print" data-testid="lang-toggle">
    {["fr", "es"].map((code) => {
      const active = lang === code;
      return (
        <button
          key={code}
          onClick={() => onChange(code)}
          data-testid={`lang-${code}`}
          className={`px-4 py-2 min-h-[36px] rounded-full text-sm font-medium transition-all ${
            active ? "bg-[var(--gold)] text-white shadow-sm" : "text-[var(--ink-soft)] hover:text-[var(--gold)]"
          }`}
        >
          {LABELS[code]}
        </button>
      );
    })}
  </div>
);
